import {
  AccountAlreadyExists,
  DuplicateTokenPendingInvite,
  ErxFallback,
  InvalidTokenPendingInvite,
  ScriptAwaitingReview,
  ScriptValid,
  ScriptValidOOS,
  SubmitToken,
} from '@/components/escript/landing/PreOnboardingFlowComponents';
import { usePreOnboardingContext } from '@/hooks/escript/usePreOnboardingContext';

export interface PreOnboardingContentFlowProps {
  setOpenTokenDialog: (state: boolean) => void;
  openTokenDialog: boolean;
}

export const PreOnboardingFlowContainer = ({ setOpenTokenDialog, openTokenDialog }: PreOnboardingContentFlowProps) => {
  const { preOnboardingState } = usePreOnboardingContext();

  const PreOnboardingSteps = {
    SUBMIT_TOKEN: <SubmitToken setOpenTokenDialog={setOpenTokenDialog} openTokenDialog={openTokenDialog} />,
    SCRIPT_VALID: <ScriptValid />,
    SCRIPT_AWAITING_REVIEW: <ScriptAwaitingReview />,
    SCRIPT_VALID_OUT_OF_STOCK: <ScriptValidOOS />,
    INVALID_TOKEN_PENDING_INVITE: <InvalidTokenPendingInvite />,
    ACCOUNT_ALREADY_EXISTS: <AccountAlreadyExists />,
    DUPLICATE_TOKEN_PENDING_INVITE: <DuplicateTokenPendingInvite />,
    ERX_FALLBACK_STRATEGY: <ErxFallback />,
  };

  return PreOnboardingSteps[preOnboardingState];
};
